import { MtAccountUserGroup } from "server/models"
import { GET, POST, DELETE } from "client/store/utils"
import { ASC } from "const"
import {
    GroupList,
    SortGroups,
} from "client/store"
import {
    UserGroupList,
    AccountGroupList,
} from "./types"

// load groups for all users in single account
export const LoadAllAccountUserGroups = (accountId: number, groupList?: GroupList) => (
    GET(`/mtAccountUserGroup/all/accountId/${accountId}`)
    .then((rows: MtAccountUserGroup[]) => {
        const userGroupList: UserGroupList = {}
        rows.forEach((row) => {
            const groupIds: number[] = userGroupList[row.userId] ? userGroupList[row.userId].slice() : []
            groupIds.push(row.groupId)
            userGroupList[row.userId] = groupIds
        })

        if (groupList) { // sort groups - used in table popover
            const sortedGroupIds: number[] = SortGroups(Object.values(groupList), "name", ASC, {})
            const sortedUserGroupList: UserGroupList = {}
            const userIds = Object.keys(userGroupList).map(Number)
            userIds.forEach((userId) => {
                const assignedGroupIds = userGroupList[userId]
                sortedUserGroupList[userId] = sortedGroupIds.filter((groupId) => assignedGroupIds.includes(groupId))
            })

            return sortedUserGroupList
        }
        return userGroupList
    })
)

// load groups in all accounts for single user
export const LoadAllUserAccountGroups = (userId: number, groupList?: GroupList) => (
    GET(`/mtAccountUserGroup/all/userId/${userId}`)
    .then((rows: MtAccountUserGroup[]) => {
        const accountGroupList: AccountGroupList = {}
        rows.forEach((row) => {
            const groupIds: number[] = accountGroupList[row.accountId] ? accountGroupList[row.accountId].slice() : []
            groupIds.push(row.groupId)
            accountGroupList[row.accountId] = groupIds
        })

        if (groupList) { // sort groups - used in table popover
            const sortedGroupIds: number[] = SortGroups(Object.values(groupList), "name", ASC, {})
            const sortedAccountGroupList: AccountGroupList = {}
            const accountIds = Object.keys(accountGroupList).map(Number)
            accountIds.forEach((accountId) => {
                const assignedGroupIds = accountGroupList[accountId]
                sortedAccountGroupList[accountId] = sortedGroupIds.filter((groupId) => assignedGroupIds.includes(groupId))
            })

            return sortedAccountGroupList
        }
        return accountGroupList
    })
)

export const LoadUserGroups = (userId: number, accountId: number, groupList?: GroupList) => (
    GET(`/mtAccountUserGroup/userGroups/${userId}/${accountId}`)
    .then((rows: MtAccountUserGroup[]) => {
        const groupIds: number[] = []
        rows.forEach((row) => {
            groupIds.push(row.groupId)
        })

        if (groupList) { // sort groups - used in table popover
            const sortedGroupIds: number[] = SortGroups(Object.values(groupList), "name", ASC, {})
            return sortedGroupIds.filter((groupId) => groupIds.includes(groupId))
        }
        return groupIds
    })
)

export const AddAccountUserGroup = (data: MtAccountUserGroup[]) => (
    POST(
        "/mtAccountUserGroup/add",
        JSON.stringify(data),
    )
)

export const DeleteAccountUserGroup = (userId: number, accountId: number, groupId: number) => (
    DELETE(`/mtAccountUserGroup/delete/${userId}/${accountId}/${groupId}`)
    .then((removedRows: number) => removedRows)
)
